import { Suspense, useEffect } from 'react'
import { DevTools } from './components/dev-tools'
import MultiPage from './features/multi-page/page'
import { enterFrom, enterFromMetadata } from './params'
import { native } from '@forest/native-services'

export function App() {
  useEffect(() => {
    let metadata = {}
    if (enterFromMetadata) {
      try {
        metadata = JSON.parse(enterFromMetadata)
      } catch (e) {
        console.error(e)
      }
    }
    native.general.logEvent({
      event_name: 'cta_to_paywall',
      event_params: {
        source: enterFrom ?? 'unknwon',
        ...metadata,
      },
    })
  }, [])
  return (
    <>
      <Suspense>
        <MultiPage />
      </Suspense>
      {import.meta.env.MODE !== 'production' && <DevTools />}
    </>
  )
}
